<template>
  <div class="table">
    <!-- 病属 -->
    <div v-for="(item,index) in tableData" :key="index">
      <div class="add-subject">
        <div
          class="add-subject-header"
          @click="$emit('selectIndex',index)"
        >
          <h3 class="inter-line">{{item.name}}</h3>
          <i class="el-icon-caret-bottom" v-if="showPro===index"></i>
          <i class="el-icon-caret-right" v-else></i>
        </div>
      </div>
      <div v-show="showPro===index" class="list">
        <el-card
          class="box-card box-card-item"
          v-for="(itemPro,indexPro) in item.child_list"
          :key="indexPro"
          shadow="never"
        >
          <div>
            <el-button
              class="modify-botton"
              type="text"
              @click="$emit('modifyPro',index,item,itemPro)"
            >修改</el-button>
            <el-button
              class="delete-botton"
              type="text"
              @click="$emit('deletePro',index,item,itemPro)"
            >删除</el-button>
          </div>
          <p class="property-name">{{itemPro.name}}</p>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tableData", "showPro", "selectIndex"]
};
</script>

<style scoped src="../style/index.css"></style>